import BigNumber from 'bignumber.js';

export function multiplyByQuantity(
  value: number | BigNumber,
  quantity: number | BigNumber,
  precision: number
): BigNumber {
  return new BigNumber(value).multipliedBy(quantity).decimalPlaces(precision);
}
